// extracted by mini-css-extract-plugin
module.exports = {"heroWrap":"Hero_heroWrap__KjfEs","blogCanvas":"Hero_blogCanvas__uleIl","title":"Hero_title__L5zK0","searchBar":"Hero_searchBar__9bm6n","icon":"Hero_icon__wGPNm"};